import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Stack,
    TextField,
} from '@mui/material';

import { Brand, Product } from '@barboxx/models';

interface Props {
    product: Product;
    brand: Brand;
}

export const BaseProductCard = ({ product, brand }: Props) => {
    return (
        <Card>
            <CardHeader
                title="Base Product"
                action={
                    <Button
                        variant="contained"
                        href={`/products/${product.id}`}
                    >
                        Go To
                    </Button>
                }
            />
            <CardContent>
                <Stack gap={2}>
                    <TextField
                        fullWidth
                        disabled
                        label="Brand"
                        value={brand.name}
                    />
                    <TextField
                        fullWidth
                        disabled
                        label="Name"
                        value={product.name}
                    />
                    <TextField
                        fullWidth
                        disabled
                        label="Description"
                        value={product.description}
                    />
                    <TextField
                        fullWidth
                        disabled
                        label="ABV Range"
                        value={product.abvPercentage}
                    />
                </Stack>
            </CardContent>
        </Card>
    );
};
